'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 */
var TabPanel = function TabPanel(_ref) {
	var id = _ref.id;
	var tabId = _ref.tabId;
	var name = _ref.name;
	var _ref$active = _ref.active;
	var active = _ref$active === undefined ? false : _ref$active;
	var children = _ref.children;

	var className = (0, _classnames2.default)(_defineProperty({
		'rea11y-TabPanel': true,
		'rea11y-TabPanel--active': active
	}, 'rea11y-TabPanel-' + name, true));

	return _react2.default.createElement(
		'div',
		{
			id: id,
			className: className,
			role: 'tabpanel',
			'aria-hidden': !active,
			'aria-labelledby': tabId,
			tabIndex: active ? 0 : -1
		},
		children
	);
};

TabPanel.propTypes = {
	id: _react.PropTypes.string,
	tabId: _react.PropTypes.string,
	name: _react.PropTypes.string,
	active: _react.PropTypes.bool,
	children: _react.PropTypes.node.isRequired
};

exports.default = (0, _recompose.pure)(TabPanel);